import { StandardEvents } from '@shopify/events';
import { scrollTo, getScrollTop } from '@theme/scroll-container';

const SCROLL_GAP = 16;

class SimucubeCartNotice extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const { signal } = this.#abortController;

    document.addEventListener(StandardEvents.cartError, this.#handleCartError, { signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate, { signal });
    this.querySelector('[data-cart-notice-close]')?.addEventListener('click', () => this.#hide(), { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #isFromSection(event) {
    const section = this.closest('.shopify-section');
    return !!section && event.target instanceof Element && section.contains(event.target);
  }

  #handleCartError = (event) => {
    if (!this.#isFromSection(event) || !event.error) return;

    const text = this.querySelector('[data-cart-notice-text]');
    if (text) text.textContent = event.error;
    this.hidden = false;
    requestAnimationFrame(() => this.#scrollIntoView());
  };

  #scrollIntoView() {
    const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    const top = this.getBoundingClientRect().top + getScrollTop() - headerHeight - SCROLL_GAP;
    scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  #handleCartUpdate = (event) => {
    if (this.#isFromSection(event)) this.#hide();
  };

  #hide() {
    this.hidden = true;
  }
}

if (!customElements.get('simucube-cart-notice')) {
  customElements.define('simucube-cart-notice', SimucubeCartNotice);
}
